import * as views from "../views";
import { AgencyRoot } from "@/pages";
import { i18nFormat } from "@/i18n.js";

export default [
  {
    path: "login",
    name: "AgencyLogin",
    component: views.Login,
    meta: {}
  },
  {
    path: "password/forgot",
    name: "AgencyForgot",
    component: views.Forgot,
    meta: {}
  },
  {
    path: "password/new",
    name: "AgencyReset",
    component: views.Reset,
    meta: {}
  },
  {
    path: "register",
    name: "AgencyRegister",
    component: views.Register,
    meta: {}
  },
  {
    path: "",
    component: AgencyRoot,
    meta: {
      headerVisible: true,
      headerTitle: i18nFormat("t", "agency.storeManager"),
      headerDescription: i18nFormat("t", "agency.headerDesc"),
      headerDomain: null,
      allowAutoSidebar: true
    },
    children: [
      {
        path: "dashboard",
        name: "AgencyDashboard",
        component: views.Dashboard,
        meta: {
          headerVisible: true,
          headerTitle: i18nFormat("t", "agency.storeManager"),
          headerDescription: i18nFormat("t", "agency.headerDesc"),
          headerDomain: null,
          allowAutoSidebar: true
        }
      },
      {
        path: "settings",
        name: "AgencySettings",
        component: views.Settings,
        meta: {
          headerVisible: true,
          headerTitle: i18nFormat("t", "accountSettings.headerTitle"),
          headerDescription: i18nFormat("t", "accountSettings.headerDesc"),
          headerDomain: null,
          allowAutoSidebar: true
        }
      }
    ]
  }
];
